
import React from 'react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { UserPlus, RefreshCcw } from 'lucide-react';
import { Label } from '@/components/ui/label';
import FamilyMembersList from './FamilyMembersList';
import { Family, FamilyMember } from './types';

interface FamilyContentProps {
  family: Family;
  members: FamilyMember[];
  currentUserId?: string;
  onInviteMember: () => void;
  onRemoveMember: (member: FamilyMember) => void;
  onRefresh: () => void;
}

const FamilyContent = ({ 
  family, 
  members, 
  currentUserId, 
  onInviteMember, 
  onRemoveMember,
  onRefresh
}: FamilyContentProps) => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start gap-4">
        <div className="w-full text-center sm:text-left">
          <Label className="block font-medium text-lg">{family.name}</Label>
          <p className="text-sm text-muted-foreground mt-1">
            Your family group for sharing quotes and milestones
          </p>
        </div>
        <Button 
          variant="outline" 
          onClick={onInviteMember}
          className="min-w-[140px] flex items-center justify-center gap-2"
        >
          <UserPlus className="h-4 w-4" />
          Invite Member
        </Button>
      </div>
      
      <Separator className="my-4" />
      
      <div>
        <h3 className="text-md font-medium mb-4">Family Members</h3>
        <FamilyMembersList 
          members={members} 
          currentUserId={currentUserId} 
          onRemoveMember={onRemoveMember} 
        />
      </div>
      
      <div className="flex justify-end pt-4">
        <Button 
          variant="outline" 
          size="sm"
          onClick={onRefresh}
          className="flex items-center gap-2"
        >
          <RefreshCcw className="h-3.5 w-3.5" />
          Refresh
        </Button>
      </div>
    </div>
  );
};

export default FamilyContent;
